
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { toast } from '@/utils/common';
import { iGift } from '@/interface/gift';
import Upload from '@/components/ImagesUpload/upload.vue';
import { iUploadeImagesList } from '@/interface/imageUpload';
import { rules, configKindOptions } from './config';
import moment from 'moment';
@Component({
  components: {
    Upload,
  },
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
})
export default class EditGift extends Vue {
  @Prop({ default: '新增礼物' }) title!: string;
  @Prop({ default: false }) visible!: boolean;
  @Prop() staticImgUpload!: iUploadeImagesList[];
  @Prop() dynamicImgUpload!: iUploadeImagesList[];
  @Prop() giftForm!: iGift;
  kinds = [...configKindOptions];

  rules = rules;

  @Emit()
  close() {}

  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        this.$emit('saveGift');
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  resetForm(formName: string) {
    (this.$refs[formName] as any).resetFields();
    this.close();
  }
}
